/**
 * Genera un identificador client-side para React keys estables en arrays
 * cuyos ids de backend pueden regenerarse entre saves (delete+insert atómico
 * del PATCH /propuestas/v2/:id).
 */
export const generarUuid = () =>
  `k_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
